import {QualityControlApprovalsData} from "../types/quality-control-approvals.types";

export const defaultQualityControlApprovalsData: QualityControlApprovalsData = {
  id: 0,
  productCardQualityControlId: 0,
  approvalStatus: '',
  comment: ''
}
